import { Box, Button, Divider, Stack, SwipeableDrawer, Typography } from "@mui/material";
import type { ReactNode } from "react";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import SwipePuller from "@entrilia/shared/components/SwipePuller";

interface Props {
  open: boolean;
  onClose: () => void;
  isAnyFilterApplied?: boolean;
  onClearFilters?: () => void;
  disabled?: boolean;
  children: ReactNode;
}

const SwipeableFiltersDrawer = ({ open, onClose, isAnyFilterApplied, onClearFilters, disabled, children }: Props) => {
  return (
    <SwipeableDrawer
      open={open}
      anchor="bottom"
      disableSwipeToOpen
      slotProps={{
        backdrop: { onClick: onClose },
      }}
      onClose={onClose}
      onOpen={() => undefined}
      swipeAreaWidth={20}
      sx={{ zIndex: 1300, "& .MuiDrawer-paper": { borderTopLeftRadius: 8, borderTopRightRadius: 8 } }}
    >
      <SwipePuller />
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", px: 2, py: 1.5 }}>
        <Button
          variant="text"
          size="small"
          onClick={onClearFilters}
          disabled={disabled}
          sx={{ justifySelf: "start", visibility: onClearFilters && isAnyFilterApplied ? "visible" : "hidden" }}
        >
          Clear all
        </Button>
        <Typography variant="subtitle1">Filters</Typography>
        <CloseIconButton onClick={onClose} sx={{ justifySelf: "end" }} />
      </Box>
      <Divider />
      <Stack spacing={2} sx={{ px: 2, pt: 2, pb: 3 }}>
        {children}
      </Stack>
    </SwipeableDrawer>
  );
};

export default SwipeableFiltersDrawer;
